export default __webpack_public_path__ + "static/media/risk-fofac-h.8385260d.png";